import React, { useContext } from "react";
import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
} from "@chakra-ui/react";
import GenericSection from "./genericSection";
import { LanguageContext } from "../components/LanguageProvider"; // Import kontekstu językowego
import { messages } from "../intl/config"; // Import tłumaczeń

type Faq = {
  question: string;
  answer: string;
};

function Questions(): JSX.Element {
  const { locale = "en" } = useContext(LanguageContext); // Uzyskanie bieżącego języka
  const translations = messages[locale] || {}; // Dostępne tłumaczenia na podstawie języka

  const faqs: Faq[] = [
    {
      question: translations["faqs.question1"],
      answer: translations["faqs.answer1"],
    },
    {
      question: translations["faqs.question2"],
      answer: translations["faqs.answer2"],
    },
    {
      question: translations["faqs.question3"],
      answer: translations["faqs.answer3"],
    },
    {
      question: translations["faqs.question4"],
      answer: translations["faqs.answer4"],
    },
    {
      question: translations["faqs.question5"],
      answer: translations["faqs.answer5"],
    },
//     {
//       question: translations["faqs.question6"],
//       answer: translations["faqs.answer6"],
//     },
  ];

  return (
    <Accordion allowToggle>
      {faqs.map((faq: Faq, index: number) => (
        <AccordionItem
          key={index}
          border="1px"
          borderColor="gray.50"
          borderRadius="md"
          mb={2}
        >
          <AccordionButton>
            <Box flex="1" textAlign="left" fontWeight={"semibold"}>
              {faq.question}
            </Box>
            <AccordionIcon />
          </AccordionButton>
          <AccordionPanel>{faq.answer}</AccordionPanel>
        </AccordionItem>
      ))}
    </Accordion>
  );
}

function Faqs(): JSX.Element {
  const { locale } = useContext(LanguageContext); // Uzyskanie bieżącego języka
  const translations = messages[locale] || {}; // Tłumaczenia na podstawie języka

  return (
    <GenericSection
      badge="FAQS"
      title={translations["faqs.title"]}
      text={translations["faqs.text"]}
      component={<Questions />}
      textOnLeft={true}
      cta={translations["faqs.cta"]}
    />
  );
}

export default Faqs;
